import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    myScheduleFilter: {
        ScheduleCode: '',
        Survey_from_date: '',
        Survey_end_date: '',
        TechnologyId: '',
        WorksiteId: '',
        EmployeeId: '',
        EquipmentID: '',
        project: '',
        ScheduleStatus: '',
        schedule_process_status: ''
    },
};

const myScheduleFilterSlice = createSlice({
    name: `myScheduleFilter`,
    initialState,
    reducers: {
        setMyScheduleFilter: (state, action) => {
            state.myScheduleFilter = action.payload;
        },
        resetScheduleFilters: (state) => {
            state.myScheduleFilter = initialState.myScheduleFilter;
        }
    }
})

export const { setMyScheduleFilter, resetMyScheduleFilter } = myScheduleFilterSlice.actions;
export default myScheduleFilterSlice.reducer;